import { pick } from 'ramda';
import { AxesWrapper, GridWrapper } from './axes.styles';

export const ChartAxesMixin = {
  props: {
    axesWrapper: { default: AxesWrapper },
    gridWrapper: { default: GridWrapper },

    topAxisVisible: { type: Boolean, default: true },
    topAxisSpace: { type: String, default: 'auto' },
    topAxisCustom: { type: Function, default: () => {} },

    rightAxisVisible: { type: Boolean, default: true },
    rightAxisSpace: { type: String, default: 'auto' },
    rightAxisCustom: { type: Function, default: () => {} },

    bottomAxisVisible: { type: Boolean, default: true },
    bottomAxisSpace: { type: String, default: 'auto' },
    bottomAxisCustom: { type: Function, default: () => {} },

    leftAxisVisible: { type: Boolean, default: true },
    leftAxisSpace: { type: String, default: 'auto' },
    leftAxisCustom: { type: Function, default: () => {} },

    xGridVisible: { type: Boolean, default: false },
    xGridCustom: { type: Function, default: () => {} },

    yGridVisible: { type: Boolean, default: false },
    yGridCustom: { type: Function, default: () => {} },
  },
  computed: {
    axesAttrs() {
      return pick(Object.keys(ChartAxesMixin.props), this);
    },
  },
};
